import React from "react";
import { useTranslation } from "react-i18next";
import Icons from "../../../Assets/Icons";
import "./PatientHistoryDetails.css";

const PatientHistoryItem = ({ historyItem, isExpanded, onToggle }) => {
    const { t } = useTranslation();

    const {
        date,
        serviceType,
        scheduledTime,
        checkInTime,
        checkOutTime,
        fee,
        staffName,
        staffId,
        patientAddress,
        woundCare,
        notes,
    } = historyItem;

    return (
        <div className="phi-item">
            <div className="phi-header" onClick={onToggle}>
                <div className="phi-left">
                    <div className="phi-date-icon">
                        <img src={Icons.CalenderIcon} alt="calendar" />
                    </div>
                    <div className="phi-info">
                        <p className="phi-date">{date}</p>
                        <p className="phi-service">{serviceType}</p>
                    </div>
                </div>
                <div className="phi-toggle">
                    <img
                        src={Icons.downArrow}
                        alt="toggle"
                        className={`phi-arrow-icon ${isExpanded ? "open" : ""}`}
                    />
                </div>
            </div>

            {isExpanded && (
                <div className="phi-content">
                    {/* Session details grid */}
                    <div className="phi-details-grid">
                        {scheduledTime && (
                            <div className="phi-detail-item">
                                <span className="phi-label">{t("sessionHours")}</span>
                                <span className="phi-value">{scheduledTime}</span>
                            </div>
                        )}
                        {checkInTime && (
                            <div className="phi-detail-item">
                                <span className="phi-label">{t("checkInTime")}</span>
                                <span className="phi-value">{checkInTime}</span>
                            </div>
                        )}
                        {checkOutTime && (
                            <div className="phi-detail-item">
                                <span className="phi-label">{t("checkOutTime")}</span>
                                <span className="phi-value">{checkOutTime}</span>
                            </div>
                        )}
                        {fee && (
                            <div className="phi-detail-item">
                                <span className="phi-label">{t("fee") || "Fee"}</span>
                                <span className="phi-value">{fee}</span>
                            </div>
                        )}
                        {staffName && (
                            <div className="phi-detail-item">
                                <span className="phi-label">{t("homecareStaff")}</span>
                                <span className="phi-value">{staffName}{staffId ? ` (${staffId})` : ""}</span>
                            </div>
                        )}
                        {patientAddress && (
                            <div className="phi-detail-item phi-detail-full">
                                <span className="phi-label">{t("serviceAddress") || "Service Address"}</span>
                                <span className="phi-value">{patientAddress}</span>
                            </div>
                        )}
                    </div>

                    {/* Observations */}
                    <div className="phi-nurse-observations">
                        <p className="phi-section-title">{t("nurseObservations")}</p>
                        {woundCare?.images?.length > 0 ? (
                            <div className="phi-images-gallery">
                                {woundCare.images.map((image, index) => (
                                    <div key={index} className="phi-image-wrapper">
                                        <img
                                            src={typeof image === "string" ? image : image?.url || image}
                                            alt={`wound care ${index + 1}`}
                                            className="phi-image"
                                        />
                                        <div className="phi-image-overlay">
                                            <img src={Icons.eye} alt="view" className="phi-eye-icon" />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p style={{ fontSize: "1.3rem", color: "#888" }}>{t("noObservationAttachmentsAdded", "No observation attachments added")}</p>
                        )}
                        {woundCare?.observations && woundCare.observations !== "-" && (
                            <p className="phi-text" style={{ marginTop: "0.8rem" }}>{woundCare.observations}</p>
                        )}
                    </div>

                    {/* Notes */}
                    {(notes || woundCare?.notes) && (notes !== "-" || woundCare?.notes !== "-") && (
                        <div className="phi-nurse-notes">
                            <p className="phi-label">{t("nurseNotes")}</p>
                            <p className="phi-text">{notes || woundCare?.notes}</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default PatientHistoryItem;
